<template>
    <ColumnaIzquierda></ColumnaIzquierda>
    <ConfirmarEnvio></ConfirmarEnvio>
</template>
<script>
import ColumnaIzquierda from '../components/ColumnaIzquierda.vue';
import ConfirmarEnvio from '../components/ConfirmarEnvio.vue';
export default {
    name: 'ConfirmView',
    components: {
        ColumnaIzquierda,
        ConfirmarEnvio,
    }
}
</script>